module.exports = __webpack_public_path__ + "static/media/play-circle.a006a051.svg";